import axios from 'axios';

const API_URL = process.env.REACT_APP_APIWPP_URL; // Substitua pela URL da sua API

// Header de autenticação exigido pelo serviço de WhatsApp (ver app.js do WPP).
// A chave fica visível no bundle do navegador — ver aviso no app.js do WPP
// sobre a limitação desse modelo e o caminho recomendado a médio prazo
// (frontend passar a chamar via backend principal em vez de direto).
const wppAuthHeaders = () => ({
  headers: { 'x-api-key': process.env.REACT_APP_WPP_API_KEY },
});

export const enviaMensagem = async (mensagem, destino, dado, callback) => {
  try {
    const response = await axios.post(`${API_URL}/enviamensagem`, {mensagem, destino, dado}, wppAuthHeaders());
    if (response.status !== 200) {
      return {ok: false, msg: 'Erro ao buscar dados da API'}
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    if (data.status){
      if (callback) {
        callback(true, data.msg);
      }
      return {ok: true, msg: data.msg};
    }
    callback(false, `Erro ao buscar dados da API`);
    return {ok: false, msg: `Erro ao buscar dados da API`}
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    if (callback) {
      callback(false, `Erro ao buscar dados da API`);
    }
    return {ok: false, msg: `Erro ao buscar dados da API`}
    // throw error;
  }
};

export const status = async () => {
  try {
    const response = await axios.get(`${API_URL}/status`, wppAuthHeaders());
    if (response.status !== 200) {
      return {ok: false, msg: 'Erro ao buscar dados da API'}
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return {ok: true, qrcode: data.qrcode, connected: data.connected};
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return {ok: false, msg: `Erro ao buscar dados da API`}
    // throw error;
  }
};